import React, { useCallback, useEffect, useState } from "react";
import {
  Modal,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  Image,
  Skeleton
} from "@heroui/react";
import dayjs from 'dayjs';
import { useParams } from "react-router-dom";
import { OrderTrackDetails } from "../../api/methods-marketplace";

const TrackPackagePopup = ({
  isOpen,
  onOpenChange,
  nftImage,
}) => {

  const { slug } = useParams();
  const [assetTrackingData, setAssetTrackingData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAssetsTrackingData = useCallback(async () => {

    if (!slug && !isOpen) return;
    try {
      setIsLoading(true);
      const response = await OrderTrackDetails(slug);

      if (response?.status === 200) {
        setAssetTrackingData(response.data);
      } else {
        throw new Error("Failed to fetch tracking details");
      }
    } catch (error) {
      console.error("Tracking Fetch Error:", error);
    } finally {
      setIsLoading(false);
    }
  }, [slug, isOpen]);

  useEffect(() => {
    fetchAssetsTrackingData();
  }, [fetchAssetsTrackingData]);

  console.log(assetTrackingData?.info, "assetTrackingData");

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="sm"
      classNames={{
        closeButton: "hidden"
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalBody className="gap-0">
              {isLoading ? (
                <>
                  <div className="nft-details flex flex-col gap-3 py-6">
                    <Skeleton className="w-[11.25rem] h-4 rounded-md mx-auto"></Skeleton>
                    <Skeleton className="w-[6.25rem] h-[6.25rem] rounded-lg mx-auto"></Skeleton>
                    <Skeleton className="w-[11.25rem] h-4 rounded-md mx-auto"></Skeleton>
                  </div>
                  <div
                    className={`flex flex-col border-t border-[#00000066] pt-8 px-3 nft-track-container`}
                  >
                    <div className="flex gap-2.5 nft-track-wrapper">
                      <Skeleton className="w-[2rem] h-[2rem] rounded-full"></Skeleton>
                      <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                        <Skeleton className="w-full h-6 rounded-md"></Skeleton>
                        <div className="flex items-center gap-4">
                          <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                          <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-2.5 nft-track-wrapper">
                      <Skeleton className="w-[2rem] h-[2rem] rounded-full"></Skeleton>
                      <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                        <Skeleton className="w-full h-6 rounded-md"></Skeleton>
                        <div className="flex items-center gap-4">
                          <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                          <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-2.5 nft-track-wrapper">
                      <Skeleton className="w-[2rem] h-[2rem] rounded-full"></Skeleton>
                      <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                        <Skeleton className="w-full h-6 rounded-md"></Skeleton>
                        <div className="flex items-center gap-4">
                          <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                          <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-2.5 nft-track-wrapper">
                      <Skeleton className="w-[2rem] h-[2rem] rounded-full"></Skeleton>
                      <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                        <Skeleton className="w-full h-6 rounded-md"></Skeleton>
                        <div className="flex items-center gap-4">
                          <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                          <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {
                    assetTrackingData?.status === "pending" ? (
                      <>
                        <div className="nft-details flex flex-col gap-4 py-6">
                          <h1 className="m-0 text-2xl text-center text-black font-bold">
                            Track Package
                          </h1>
                          <Image
                            alt="nft-image"
                            src={nftImage}
                            className="w-[6.25rem] h-[6.25rem] object-cover rounded-lg"
                            classNames={{
                              wrapper: "block mx-auto w-fit"
                            }}
                          />
                          <p className="m-0 text-[1.625rem] text-center text-black font-semibold">
                            #127777489-DL-NY
                          </p>
                        </div>
                        <div
                          className={`flex flex-col border-t border-[#00000066] pt-8 px-3 nft-track-container ${assetTrackingData?.status}`}
                        >
                          <div className="flex gap-2.5 nft-track-wrapper">
                            <div className="first-round">
                              <div className="inner-round"></div>
                            </div>
                            <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                              <h1 className="m-0 text-sm leading-6 text-black font-semibold">
                                Order Confirmed
                              </h1>
                              <div className="flex items-center gap-4">
                                <p className="m-0 text-black text-xs">
                                  Date: --/--/----
                                </p>
                                <p className="m-0 text-black text-xs">Time: --:--</p>
                              </div>
                            </div>
                          </div>
                          <div className="flex gap-2.5 nft-track-wrapper">
                            <div className="first-round">
                              <div className="inner-round"></div>
                            </div>
                            <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                              <h1 className="m-0 text-sm leading-6 text-black font-semibold">
                                Shipped
                              </h1>
                              <div className="flex items-center gap-4">
                                <p className="m-0 text-black text-xs">
                                  Date: --/--/----
                                </p>
                                <p className="m-0 text-black text-xs">Time: --:--</p>
                              </div>
                            </div>
                          </div>
                          <div className="flex gap-2.5 nft-track-wrapper">
                            <div className="first-round">
                              <div className="inner-round"></div>
                            </div>
                            <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                              <h1 className="m-0 text-sm leading-6 text-black font-semibold">
                                Out For Delivery
                              </h1>
                              <div className="flex items-center gap-4">
                                <p className="m-0 text-black text-xs">
                                  Date: --/--/----
                                </p>
                                <p className="m-0 text-black text-xs">Time: --:--</p>
                              </div>
                            </div>
                          </div>
                          <div className="flex gap-2.5 nft-track-wrapper">
                            <div className="first-round">
                              <div className="inner-round"></div>
                            </div>
                            <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                              <h1 className="m-0 text-sm leading-6 text-black font-semibold">
                                Delivered
                              </h1>
                              <div className="flex items-center gap-4">
                                <p className="m-0 text-black text-xs">
                                  Date: --/--/----
                                </p>
                                <p className="m-0 text-black text-xs">Time: --:--</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="nft-details flex flex-col gap-4 py-6">
                          <h1 className="m-0 text-2xl text-center text-black font-bold">
                            Track Package
                          </h1>
                          <Image
                            alt="nft-image"
                            src={nftImage}
                            className="w-[6.25rem] h-[6.25rem] object-cover rounded-lg"
                            classNames={{
                              wrapper: "block mx-auto w-fit"
                            }}
                          />
                          <p className="m-0 text-[1.625rem] text-center text-black font-semibold">
                            #127777489-DL-NY
                          </p>
                        </div>
                        <div
                          className={`flex flex-col border-t border-[#00000066] pt-8 px-3 nft-track-container ${assetTrackingData?.status}`}
                        >
                          {
                            assetTrackingData?.info && Array.isArray(assetTrackingData?.info) && assetTrackingData?.info?.slice().reverse().map((item, index) => {
                              const date = dayjs(item.datetime).format('DD/MM/YYYY');
                              const time = dayjs(item.datetime).format('HH:mm');
                              return (
                                <div key={index} className="flex gap-2.5 nft-track-wrapper">
                                  <div className="first-round">
                                    <div className="inner-round"></div>
                                  </div>
                                  <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                                    <h1 className="m-0 text-sm leading-6 text-black font-semibold">
                                    {item.status || 'Status Unknown'}
                                    </h1>
                                    <div className="flex items-center gap-4">
                                      <p className="m-0 text-black text-xs">Date: {date}</p>
                                      <p className="m-0 text-black text-xs">Time: {time}</p>
                                    </div>
                                  </div>
                                </div>
                              )
                            })
                          }
                        </div>
                        {/* <div
                          className={`flex flex-col border-t border-[#00000066] pt-8 px-3 nft-track-container ${assetTrackingData?.status}`}
                        >
                          <div className="flex gap-2.5 nft-track-wrapper">
                            <div className="first-round">
                              <div className="inner-round"></div>
                            </div>
                            <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                              <h1 className="m-0 text-sm leading-6 text-black font-semibold">
                                Order Confirmed
                              </h1>
                              <div className="flex items-center gap-4">
                                <p className="m-0 text-black text-xs">
                                  Date: 25/03/2025
                                </p>
                                <p className="m-0 text-black text-xs">Time: 09:00</p>
                              </div>
                            </div>
                          </div>
                          <div className="flex gap-2.5 nft-track-wrapper">
                            <div className="first-round">
                              <div className="inner-round"></div>
                            </div>
                            <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                              <h1 className="m-0 text-sm leading-6 text-black font-semibold">
                                Shipped
                              </h1>
                              <div className="flex items-center gap-4">
                                <p className="m-0 text-black text-xs">
                                  Date: 27/03/2025
                                </p>
                                <p className="m-0 text-black text-xs">Time: 10:00</p>
                              </div>
                            </div>
                          </div>
                          <div className="flex gap-2.5 nft-track-wrapper">
                            <div className="first-round">
                              <div className="inner-round"></div>
                            </div>
                            <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                              <h1 className="m-0 text-sm leading-6 text-black font-semibold">
                                Out For Delivery
                              </h1>
                              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                                <p className="m-0 text-black text-xs">
                                  <span className="font-semibold">Estimated: </span>
                                  Date: 30/03/2025
                                </p>
                                <p className="m-0 text-black text-xs">Time: 09:00</p>
                              </div>
                            </div>
                          </div>
                          <div className="flex gap-2.5 nft-track-wrapper">
                            <div className="first-round">
                              <div className="inner-round"></div>
                            </div>
                            <div className="flex flex-col gap-2 w-[calc(100%-2.625rem)]">
                              <h1 className="m-0 text-sm leading-6 text-black font-semibold">
                                Delivered
                              </h1>
                              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                                <p className="m-0 text-black text-xs">
                                  <span className="font-semibold">Estimated: </span>
                                  Date: 31/03/2025
                                </p>
                                <p className="m-0 text-black text-xs">Time: 09:00</p>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </>
                    )
                  }

                </>
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="danger" variant="flat" onPress={onClose}>
                Close
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default TrackPackagePopup;
